import { RichTextField, ImageField, ColorField } from "./fields";

export default function ImageWithTextFields(props) {
  return (
    <>
      <ImageField name="image" label="Image" />
      <RichTextField
        name="text"
        label="Text"
        placeholder="Some Text"
        multiline
        rows={15}
      />
      <ColorField name="color" label="Text Color" />
    </>
  );
}
